export default __webpack_public_path__ + "static/pour-8879b404164eeaa11eb1c2113bbfc9b2.png";